import { Fragment } from 'react'

import PageLoader from 'Layout/PageLoader'

import InstallRestAPI from './InstallRestAPI'
import APIToken from './APIToken'
import UnInstallRestAPI from './UnInstallRestAPI'

import { useGetAppQuery } from './rest-api.service'

const RestAPI = () => {
  const { isLoading, isError, error, data: restAPI = {} } = useGetAppQuery(null)

  if (isLoading) {
    return <PageLoader />
  }

  if ((isError && error.status === 404) || !restAPI.is_active) {
    return <InstallRestAPI />
  }

  return (
    <Fragment>
      <APIToken />
      <UnInstallRestAPI />
    </Fragment>
  )
}

export default RestAPI
